import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { InfiniteRowModelModule } from "@ag-grid-community/infinite-row-model";
/**
 * AG Grid module registration — import this once at app startup.
 * All AG Grid instances will use these modules automatically.
 */
import { ModuleRegistry } from "@ag-grid-community/core";

ModuleRegistry.registerModules([
	ClientSideRowModelModule,
	InfiniteRowModelModule,
]);
